import VueRouter from 'vue-router'
import { Store } from 'vuex'

export default {
  handler(router: VueRouter, store: Store<any>, error: any) {
    const authUrl = `${process.env.VUE_APP_SERVER_SIDE_APP_URL}/Security/LogIn`

    window.location.href = authUrl
  },
}
